import {MigrationManifest, PersistedState} from "redux-persist";

/**
 * redux persist - localstorage migrations
 */
const migrations: MigrationManifest = {
	/**
	 * @description 최초작성
	 */
	0: (state: PersistedState) => ({
		...state,
	}),
};

export default migrations;
